import React from 'react';
import Icon from './Icon';

export default class Star extends Icon {
  static defaultProps = {
    color: undefined, // inherit from wrapper element the color
    size: 24,
  };

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 14 14"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.876 13.7c-.817-.432-1.625-.883-2.422-1.353-.12-.07-.243-.143-.38-.163-.242-.035-.474.101-.685.23-.76.462-1.538.893-2.33 1.292-.473.239-1.093.446-1.475.07-.304-.298-.276-.802-.22-1.233.132-.998.29-1.992.477-2.98.033-.174.066-.357.014-.525-.052-.165-.177-.29-.299-.409L.8 6.913C.55 6.671.298 6.421.14 6.107c-.157-.315-.203-.714-.03-1.02.232-.409.744-.513 1.195-.576l2.603-.365c.18-.026.37-.055.516-.169.137-.106.216-.272.291-.432L5.85 1.122c.13-.276.262-.556.465-.777.203-.221.493-.377.785-.34.462.061.74.552.947.988.413.868.824 1.736 1.238 2.602.345.725 1 .57 1.683.674l1.671.251c.535.08 1.173.25 1.33.79.15.52-.258 1.019-.633 1.396L11.432 8.63c-.132.133-.269.275-.32.458-.048.168-.018.348.013.52l.456 2.568c.055.311.11.629.072.943-.04.313-.19.629-.456.781-.146.084-.304.11-.466.099-.289-.02-.59-.158-.855-.298z"
      />
    </svg>
  );
}
